import React from 'react';
import {oxford} from "btdt/shared";

export default function RestrictedNotice({location}) {
    if (location) {
        return (
            <div className={"font-bold"}>
                <span className={"text-[#A70000]"}>PLEASE NOTE:</span> This location does not accept {oxford(location.restricted, 'or')}.
                Please <a href={`${location.site}contact`} className={"!text-brand-blue !decoration-brand-blue hover:!decoration-transparent"}>contact
                us</a> for more information.
            </div>
        )
    }
}